<template>
<div>
  <Header title="资料设置" />
  <div class="head-portrait">
    <!-- <img :src="getAvatar(avatarImageUri)"/> -->
  </div>

  <div class="center-info">
    <div class="center-info-item center-item-box" >
      <van-cell is-link to="/center/update-general">
        <template #title>
          <span class="custom-title">修改基本信息</span>
        </template>
      </van-cell>
      <van-cell is-link to="/center/update-key" v-if="$store.state.user.userRole==='01'">
        <template #title>
          <span class="custom-title">修改关键信息</span>
        </template>
      </van-cell>
      <van-cell is-link to="/center/reset-password">
        <template #title>
          <span class="custom-title">修改密码</span>
        </template>
      </van-cell>
      <van-cell is-link to="/center/workshop-transfer" v-if="$store.state.user.userRole==='01'">
        <template #title>
          <span class="custom-title">身份转移</span>
        </template>
      </van-cell>
      <van-cell   v-if="$store.state.user.userRole!=='01'" @click="handleLogout()">
        <template #title>
          <span class="custom-title">账号注销</span>
        </template>
      </van-cell>
    </div>
  </div>

</div>
</template>

<script>
import Header from '@/components/header'
import { userUtils } from '@/utils/auth'
import centerApi from '@/api/center'
export default {
  components: {
    Header
  },
  data () {
    return {
      pointList: [],
      couponListLength: 0,
      userInfo: {}
    }
  },
  created () {
    this.init()
    this.userInfo = userUtils.getClientInfo()
  },
  methods: {
    init () {
      this.queryPointList()
      this.queryClientUserList()
    },
    queryPointList () {
      centerApi.queryPointList().then(res => {
        if (res.data.resultCode === '0') {
          this.pointList = res.data.resultData.pointList
        }
      })
    },
    queryClientUserList () {
      centerApi.queryClientUserList().then(res => {
        if (res.data.resultCode === '0') {
          this.clientUserLength = res.data.resultData.clientUserList.length
        }
      })
    },
    toUserIntegration () {
      this.$router.push({ name: 'user-integration' })
    },
    gotoWeb (name) {
      this.$router.push({ name })
    },
    handleLogout () {
      this.$dialog.confirm({
        title: '提示',
        message: '是否要注销当前账号？'
      })
        .then(() => {
          centerApi.clientUserAccountLogout().then(res => {
            if (res.data.resultCode === '0') {
              this.$toast('注销成功！')
              userUtils.removeUserLocal()
              this.$router.push({ name: 'login2' })
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    }
  }
}
</script>

<style scoped lang="less">
/* 头像 */
.head-portrait{
    position: relative;
    width: 100%;
    height: 20px;
    padding-top: 46px;
    img{
      width: 80px;
      height: 80px;
      background-color: #e41b2c;
      border-radius: 50%;
      margin-left: calc(50% - 40px);
      margin-top: 30px;
      margin-bottom: 20px;
    }
}
.center-head-portrait .center-head-portrait-bg{
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 9;
}
.center-head-portrait .center-head-portrait-wrapper{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 3.25rem;
    height: 3.25rem;
    -webkit-transform: translate(-50%,-50%);
            transform: translate(-50%,-50%);
    z-index: 10;
}
.center-head-portrait .center-head-portrait-icon{
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1.95rem;
    height: 1.95rem;
    -webkit-transform: translate(-50%,-50%);
            transform: translate(-50%,-50%);
    z-index: 10;
}

.center-info{
  margin: 0 15px;
  width: calc(100% - 30px);
}
.center-info-item{
  margin-top: 15px;
  padding-top: 0.1rem;
  padding-bottom: 0.06rem;
  background-color: #fff;
  // display: flex;
  // justify-content: space-evenly;
  // height: 60px;
  // line-height: 20px;
  // align-items: center;
  // text-align: center;
  //border-bottom: 5px solid #65bac7;
  border-radius: 5px;
}

/* 卡券积分 */
.center-integration-coupon{
    padding-top: 0.1rem;
    padding-bottom: 0.06rem;
    background-color: #fff;
    display: flex;
    justify-content: space-evenly;
    height: 60px;
    line-height: 20px;
    align-items: center;
    text-align: center;
    border-bottom: 5px solid #65bac7;
}
.center-integration-coupon-item{
  flex:1;
}
.center-integration-border{
  border-right: 1px solid #f1f1f1;
}
.center-integration-coupon-title{
    font-size:14px;
    color: #117281;
}
.center-integration-coupon-num{
    color: #e41b2c;
    font-size: 0.24rem;
}
.center-item-box{
  margin-top: 10px;
  align-items: center;
  vertical-align: middle;
  img{
    position: absolute;
    top: 12px;
    width: 18px;
    margin-right: 10px;
  }
  .custom-title{
    padding-left: 10px;
  }
}

</style>
